export default function Alert(props) {
  const { type = 'danger' } = props;
  return (
    <div class={`alert alert-${type} alert-icon`} role="alert" ref={props.ref}>
      {props.msg || props.children || ''}
    </div>
  );
}
